import React from 'react';
import Header from './Header';
import Footer from './Footer'; // If you have one

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Header />
      <div className="page-container">
        {children}
      </div>
      <Footer />
    </>
  );
};

export default Layout;